import type { JSX } from 'react';
import * as React from 'react';

import classNames from 'classnames';

import styles from './Checkbox.module.css';

type CheckboxProps = Omit<React.ComponentProps<'input'>, 'type'>;

export default function Checkbox({ className, ...props }: CheckboxProps): JSX.Element {
  return <input type="checkbox" className={classNames(styles.Input, className)} {...props} />;
}
